module.exports = __webpack_public_path__ + "static/images/xlp.3895eff.png";